
import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { ErrorBoundary } from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ThemeProvider } from '@telavita-core/react-design-kit'

import ErrorView from '~/views/ErrorView'
import MeetingView from '~/views/MeetingView'

import { FlagProvider } from '~/contexts/FlagProvider'
import { ScheduleProvider } from '~/contexts/ScheduleContext'
import { JitsiMeet } from '~/modules/Jitsi'

const queryClient = new QueryClient()

const App = () => {
  
  useEffect(() => {
    if (JitsiMeet) {
      JitsiMeet.init()
    }
  }, [])

  return (
    <div className='App'>
      <ErrorBoundary
        fallback={<ErrorView />}
        showDialog
        dialogOptions={{
          title: 'Oops! Parece que você encontrou um erro.',
          labelSubmit: 'Enviar erros',
          successMessage: 'Sua mensagem foi enviada com sucesso. Obrigado!',
        }}
      >
        <QueryClientProvider client={queryClient}>
          <FlagProvider>
            <ThemeProvider>
              <ScheduleProvider>
                <BrowserRouter>
                  <Switch>
                    <Route path='/error' component={ErrorView} />
                    <Route path='/:hash' component={MeetingView} />
                    <Route path='/' component={ErrorView} />
                  </Switch>
                </BrowserRouter>
              </ScheduleProvider>
            </ThemeProvider>
          </FlagProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </div>
  )
}

export default App
